<template>
  <div>
    <div>
      <vs-input
        name="name"
        v-model="dataTeam.name"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Team Name"
        class="w-full"
      />
    </div>
    <div>
      <vs-textarea
        name="name"
        v-model="dataTeam.description"
        icon-no-border
        label="Description"
        class="w-full"
      />
    </div>
    <div>
      <vs-input
        name="city"
        v-model="dataTeam.city"
        icon-no-border
        icon="icon icon-map-pin"
        icon-pack="feather"
        label-placeholder="City"
        class="w-full"
      />
    </div>
    <div>
      <vs-input
        name="state"
        v-model="dataTeam.state"
        icon-no-border
        icon="icon icon-map-pin"
        icon-pack="feather"
        label-placeholder="State"
        class="w-full"
      />
    </div>
    <div>
      <vs-input
        name="country"
        v-model="dataTeam.country"
        icon-no-border
        icon="icon icon-map-pin"
        icon-pack="feather"
        label-placeholder="Country"
        class="w-full"
      />
    </div>
    <vs-divider />
    <div class="my-5">
      <p>
        <b>Every Team is required to have at least one season.</b>
      </p>
      <p>
        <b>Fill in the season details below.</b>
      </p>
    </div>
    <div>
      <vs-input
        name="name"
        v-model="dataTeam.seasonName"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Season Name"
        class="w-full"
      />
    </div>
    <vs-row>
      <vs-col vs-w="6" vs-xs="12">
        <p>Season Start:</p>
        <DatePicker :config="dateRangeConfig" v-model="dataTeam.seasonStart" />
      </vs-col>
      <vs-col vs-w="6" vs-xs="12">
        <p>Season Start:</p>
        <DatePicker :config="dateRangeConfig" v-model="dataTeam.seasonEnd" />
      </vs-col>
    </vs-row>
    <div style="margin: 10px 0 0">
      <vs-button @click="createNewTeam()">
        Create Team
      </vs-button>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import UserRoles from "@/mixins/UserRoles";
import dateRangeConfig from "@/constants/date/dateRangeConfig";
import DatePicker from "vue-flatpickr-component";

export default {
  name: "create-team",
  components: {
    DatePicker
  },
  mixins: [UserRoles],
  data: () => ({
    dataTeam: {
      name: "",
      city: "",
      state: "",
      country: "",
      description: "",
      seasonName: "",
      seasonStart: null,
      seasonEnd: null
    },
    dateRangeConfig
  }),
  methods: {
    ...mapActions({
      create: "team/createTeamSeason"
    }),
    resetDataTeam() {
      this.dataTeam = {
        name: "",
        city: "",
        state: "",
        country: "",
        description: "",
        seasonName: "",
        seasonStart: null,
        seasonEnd: null
      };
    },
    async createNewTeam() {
      try {
        const { json } = await this.create({
          data: this.dataTeam,
          user: this.user
        });
        this.resetDataTeam();
        this.$toasted.success("Successfully Created Team").goAway(2000);
        this.$emit("onSuccess", json[0]);
      } catch (ex) {
        this.$toasted.error("Unable to Create Team").goAway(2000);
        this.resetDataTeam();
        this.$emit("onError");
      }
    },
    startDateChanged(d) {
      this.dataTeam.seasonStart = d;
    },
    endDateChanged(d) {
      this.dataTeam.seasonEnd = d;
    }
  }
};
</script>
